import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'

const stories = [
  {
    img: "/image/about-location-1.webp",
    subtitle: "TROPICAL LUMINANCE",
    title: "Goa",
    description: "Where golden sunlight meets swaying palms and endless horizons, tropical luminance captures the radiant spirit of Goa in its most vibrant, soul-stirring form.",
    link: "/resort-de-coracao-goa"
  },
  {
    img: "/image/about-location-2.webp",
    subtitle: "TO THE WILDS",
    title: "Jim Corbett",
    description: "Step into untamed beauty where dense forests, river whispers, and raw wilderness awaken your spirit to nature’s purest rhythm.",
    link: "/resort-de-coracao-corbett"
  },
  {
    img: "/image/about-location-3.webp",
    subtitle: "PATHWAYS TO DISCOVERY",
    title: "Rishikesh",
    description: "Where the flow of the Ganges and the calm hills inspire reflection and renewal. In Rishikesh, every step invites you to explore and discover something deeper within.",
    link: "/resort-de-coracao-rishikesh"
  },
  
  {
    img: "/image/about-location-1.webp",
    subtitle: "TROPICAL LUMINANCE",
    title: "Goa",
    description: "Where golden sunlight meets swaying palms and endless horizons, tropical luminance captures the radiant spirit of Goa in its most vibrant, soul-stirring form.",
    link: "/resort-de-coracao-goa"
  },
  {
    img: "/image/about-location-2.webp",
    subtitle: "TO THE WILDS",
    title: "Jim Corbett",
    description: "Step into untamed beauty where dense forests, river whispers, and raw wilderness awaken your spirit to nature’s purest rhythm.",
    link: "/resort-de-coracao-corbett"
  },
  {
    img: "/image/about-location-3.webp",
    subtitle: "PATHWAYS TO DISCOVERY",
    title: "Rishikesh",
    description: "Where the flow of the Ganges and the calm hills inspire reflection and renewal. In Rishikesh, every step invites you to explore and discover something deeper within.",
    link: "/resort-de-coracao-rishikesh"
  },
]

export default function AboutProperty() {
  const [currentSlide, setCurrentSlide] = useState(0)
  const sliderRef = useRef(null)
  const totalSlides = stories.length

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    pauseOnHover: false,
    beforeChange: (_, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 767,
        settings: { slidesToShow: 2 }
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 1 }
      }
    ]
  }

  const thumbWidth = (1 / totalSlides) * 100
  const thumbLeft = (currentSlide / totalSlides) * 100

  return (
    <section className="about-property">
        <div className="big-container">
            <div className="row">

                <div className="col-lg-12">
                    <h3 className="heading center-heading">Property Stories</h3>

                    <div className="property-slider-wrap">
                        <Slider ref={sliderRef} {...settings}>
                            {stories.map((story, i) => (
                            <Link to={story.link} key={i} className="property-slide-item">
                                <div className="property-card">
                                    <picture>
                                        <img src={story.img} alt={story.title} loading="lazy" />
                                    </picture>
                                    <div>
                                        <span>{story.subtitle}</span>
                                        <label>{story.title}</label>
                                        <p>{story.description}</p>
                                    </div>
                                </div>
                            </Link>
                            ))}
                        </Slider>
                    </div>

                    <div className="property-scrollbar-wrap">
                        <div className="property-scrollbar-track">
                            <div className="property-scrollbar-thumb" style={{ width: `${thumbWidth}%`, left: `${thumbLeft}%` }}/>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
  )
}
